import { TranslationMap } from '@trimble-gcs/i18n-types';

export function outOfQuotaTranslations() {
  return {
    header: {
      text: $localize`:@@quota.outOfQuota.header:Out Of Space`,
      desc: 'Header for the dialog that informs the user that there is no more space remaining.',
    },
    title: {
      text: $localize`:@@quota.outOfQuota.title:Quota Exceeded`,
      desc: 'Title for the dialog that informs the user that there is no more space remaining.',
    },
    message: {
      text: $localize`:@@quota.outOfQuota.message:Looks like you have run out of space. Clean up your data by deleting or archiving, alternatively, contact your license administrator to upgrade.`,
      desc: 'Message for the dialog that informs the user that there is no more space remaining.',
    },
    button: {
      text: $localize`:@@quota.outOfQuota.button:OK`,
      desc: 'Button to dismiss the dialog that informs the user that there is no more space remaining.',
    },
  } satisfies TranslationMap;
}
